import { render, staticRenderFns } from "./OpeningBalanceStatistics.vue?vue&type=template&id=cde010f4&scoped=true"
import script from "./OpeningBalanceStatistics.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalanceStatistics.vue?vue&type=style&index=0&id=cde010f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde010f4",
  null
  
)

export default component.exports